import React, { useState } from 'react'
import { Typography, Box, Button, TextField, MenuItem, Popover, FormControl } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useWorkspace } from '../../../../contexts/WorkspaceContext';

const customTextFieldStyles = {
"& .MuiInputLabel-root": {
  fontFamily: "Inter",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: "rgba(255, 255, 255, 0.80)",
  "&.Mui-focused": {
    color: "rgba(255, 255, 255, 0.80) !important",
  },
},
"& .MuiInputBase-input": {
  color: "#FFFFFF",
},
"& .MuiOutlinedInput-root": {
  "& fieldset": {
    borderColor: "rgba(255, 255, 255, 0.80)",
  },
  "&:hover fieldset": {
    borderColor: "rgba(255, 255, 255, 0.80)",
  },
  "&.Mui-focused fieldset": {
    borderColor: "rgba(255, 255, 255, 0.80) !important",
  },
},
"& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
  color: "rgba(255, 255, 255, 0.80) !important",
},
"& .MuiOutlinedInput-notchedOutline": {
  borderColor: "rgba(255, 255, 255, 0.80) !important",
},
"& .MuiInputBase-input.Mui-disabled": {
  WebkitTextFillColor: "rgba(255, 255, 255, 0.40)",
},
"& .MuiInputLabel-root.Mui-disabled": {
  color: "rgba(255, 255, 255, 0.40)", // New color
},
};

const Resolution = [{id:1, width:1200, height:720, value:"1200 X 720"},{id:2,width:1200, height:720, value:"1200 X 720"}]

const AdvanceSettings = () => {

const [videoName, setVideoName] = useState()
const {heygenVideoTitle, setHeygenVideoTitle} = useWorkspace()
const [selectedVideoResolution, setSelectedVideoResolution] = useState()
const [allAvalaibleResolution, setAllAvalaibleResolution] = useState(Resolution)
 const [anchorEl, setAnchorEl] = useState(null);

   const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

  const handleClose = () => {
        setAnchorEl(null);
    };
    
  const open = Boolean(anchorEl);

  return (
    <Box sx={{ padding: "20px 20px 0px 0px" }}>
           <Box sx={{display:"flex", flexDirection:"row", columnGap:"12px"}}>
               <Typography>Advanced video settings</Typography>
           </Box>
           <Box sx={{display:"flex", flexDirection:"row", justifyContent:"space-between", alignItems:"center"}}>
           <Box>
            <Box sx={{mt:3, maxWidth:"318px", width:"100%"}}>
           <Typography sx={{marginBottom:2}}>Video title</Typography>
           <Box>
                     <TextField onChange={(e)=>{setHeygenVideoTitle(e.target.value)}}
                                    type="text"
                                    value={heygenVideoTitle}
                                    id="outlined-basic"
                                    label="Enter the title of the video"
                                    variant="outlined"
                                    sx={customTextFieldStyles}
                                    style={{
                                      width: "100%", 
                                      height: "56px",
                                      color: "#FFFFFF",
                                      backgroundColor: "#232746",
                                      borderRadius: "8px",
                                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                                      placeholderfontsize: "16px",
                                      marginBottom: "36px",
                                    }}
                                  />
           </Box>
           </Box>
           <Box>

            {/* <Box sx={{mt:3, width:"100%", display:"flex", flexDirection:"row",  columnGap:"20px"}}> */}
            {/* <Box>
           <Typography sx={{marginBottom:2}}>Custom video output dimensions</Typography>
           <Box sx={{ display:"flex", flexDirection:"row", columnGap:"20px"}}>
                     <TextField
                                    type="number"
                                    // value={videoName}
                                    id="outlined-basic"
                                    label="Width*"
                                    variant="outlined"
                                    sx={customTextFieldStyles}
                                    style={{
                                      width: "146px", 
                                      height: "56px",
                                      color: "#FFFFFF",
                                      backgroundColor: "#232746",
                                      borderRadius: "8px",
                                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                                      placeholderfontsize: "16px",
                                      marginBottom: "36px",
                                    }}
                                  />
                     <TextField
                                    type="number"
                                    // value={videoName}
                                    id="outlined-basic"
                                    label="Height*"
                                    variant="outlined"
                                    sx={customTextFieldStyles}
                                    style={{
                                      width: "146px", 
                                      height: "56px",
                                      color: "#FFFFFF",
                                      backgroundColor: "#232746",
                                      borderRadius: "8px",
                                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                                      placeholderfontsize: "16px",
                                      marginBottom: "36px",
                                    }}
                                  />
           </Box>
           </Box> */}
           {/* <Box>
            <Typography sx={{marginBottom:2}}>Select preset</Typography>
            <FormControl>
                        <Button
                            onClick={handleOpen}
                            sx={{
                                color:  selectedVideoResolution ? "rgba(255, 255, 255, 1)"  : "rgba(202, 196, 208, 1)",
                                backgroundColor: "#2F355F",
                                borderRadius: "8px",
                                height: "56px",
                                minWidth: "200px",
                                textTransform: 'none',
                                fontFamily:"Inter",
                                fontWeight:400,
                                '&:hover': {
                                    backgroundColor: "#373E6D",
                                },
                            }}
                        >
                            {selectedVideoResolution || "1200 X 720"}
                            <ArrowDropDownIcon sx={{ color:  selectedVideoResolution ? "rgba(255, 255, 255, 1)"  :  "rgba(202, 196, 208, 1)", marginLeft:"auto" }} />
                        </Button>
            
                        <Popover
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            sx={{
                                '& .MuiPaper-root': {
                                    backgroundColor: "#2F355F",
                                    color: "white",
                                    borderRadius: "8px",
                                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                                    maxHeight: "300px",
                                    width: "180px",
                                    marginTop:"4px"
                                },
                            }}
                        >
            
                            <Box sx={{ overflowY: 'auto', maxHeight: 250 }}>
                                {allAvalaibleResolution?.map((resolution, index) => (
                                    <MenuItem
                                        key={index+1}
                                        // onClick={() => handleSelect(voice)}
                                        sx={{
                                            '&:hover': { backgroundColor: "#373E6D" },
                                            '&.Mui-selected': { backgroundColor: "#373E6D" },
                                            py: 1,
                                            fontSize: 14,
                                        }}
                                    >
                                        {resolution}
                                    </MenuItem>
                                ))}
                            </Box>
                        </Popover>
                    </FormControl>
           </Box> */}
           {/* </Box> */}

           </Box>
          </Box>
          </Box>
          </Box>
  )
}

export default AdvanceSettings